/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFeedGenerator.defs.js'
export { main as default } from './getFeedGenerator.defs.js'
